import { c as _c } from "react/compiler-runtime";
import { useDateTimeFormatter } from "@opensea/i18n";
import { getYear } from "date-fns";
export const useFormatStageDate = () => {
  const $ = _c(2);
  const dateFormat = useDateTimeFormatter();
  let t0;
  if ($[0] !== dateFormat) {
    t0 = dateString => {
      const date = new Date(dateString);
      const isThisYear = getYear(date) === new Date().getFullYear();
      return dateFormat(date, {
        display: "custom",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        year: isThisYear ? undefined : "numeric",
        timeZoneName: "short"
      });
    };
    $[0] = dateFormat;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};